import { render, staticRenderFns } from "./CountUp.vue?vue&type=template&id=7037a2e6&scoped=true&"
import script from "./CountUp.vue?vue&type=script&lang=js&"
export * from "./CountUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7037a2e6",
  null
  
)

export default component.exports